module.exports = __webpack_public_path__ + "media/entre.a877a8e7.mp4";